import { SegmentInterface } from 'services/analytics/segment/types';

export const logErrorEvent = ({
  segmentClient,
  error_type,
  error_step,
  error_detail,
}: {
  segmentClient: SegmentInterface;
  error_type: string;
  error_step?: string;
  /**
   * Optional flattened, primitive-valued fields describing the underlying
   * error (e.g. message, network error name, GraphQL error count). Spread
   * into the event so the failure can be diagnosed in analytics. See
   * serializeQueryError for the bill manager router query/cards errors.
   */
  error_detail?: Record<string, unknown>;
}) => {
  void segmentClient.logEvent('Bill Manager Error Encountered', {
    ...error_detail,
    category: 'bill_manager',
    error_type,
    error_step,
  });
};
